import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { http, apiErr } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Loading, StatusBadge, EmptyState } from "@/components/common";
import { toast } from "sonner";
import { FileText, Download } from "lucide-react";

export default function Preventivi() {
  const [list, setList] = useState(null);
  const nav = useNavigate();
  const { t, i18n } = useTranslation();
  const [qc, setQc] = useState(null);
  useEffect(() => { http.get("/quotes").then((r) => setList(r.data)).catch((e) => toast.error(apiErr(e))); http.get("/settings/quotes").then((r) => setQc(r.data)).catch(() => {}); }, []);
  if (!list) return <Loading />;
  return (
    <div className="max-w-4xl mx-auto p-4 sm:p-6 space-y-5" data-testid="preventivi-page">
      {qc?.enabled === false && <div className="rounded-xl border border-amber-200 bg-amber-50 text-amber-800 text-sm p-3" data-testid="quotes-disabled-banner">{t("quotes_mode.disabled_notice")}</div>}
      <div className="flex items-center justify-between">
        <h1 className="font-heading text-2xl font-extrabold text-[#0F172A]">{t("preventivi.title")}</h1>
        <a href={`${http.defaults.baseURL}/export/quotes`} download><Button variant="outline" className="gap-1.5"><Download className="w-4 h-4" /><span className="hidden sm:inline">CSV</span></Button></a>
      </div>
      {list.length === 0 ? <EmptyState icon={FileText} title={t("preventivi.empty")} hint={t("preventivi.empty_hint")} /> : (
        <div className="space-y-2">
          {list.map((q) => (
            <Card key={q.id} data-testid="quote-card" onClick={() => nav(`/preventivi/${q.id}`)} className="p-4 cursor-pointer hover:shadow-md flex items-center gap-3 border-slate-200">
              <div className="w-10 h-10 rounded-lg bg-sky-50 text-sky-600 flex items-center justify-center"><FileText className="w-5 h-5" /></div>
              <div className="flex-1 min-w-0">
                <div className="font-mono text-sm font-semibold text-[#0F172A]">{q.number}</div>
                <div className="text-xs text-slate-500">{q.customer_name} · {new Date(q.date).toLocaleDateString(i18n.language)}</div>
              </div>
              <div className="text-right"><div className="font-heading font-bold text-[#0F172A]">€ {q.total?.toFixed(2)}</div><StatusBadge status={q.status} /></div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
